import React from "react";
import styles from "./WinsAndLossesShow.module.css";
import { useSelector } from "react-redux";
import lose from "../../images/lose.webp";
import win from "../../images/win.webp";
const WinsAndLossesShow = () => {
  const gameData = useSelector((state) => state.gameData);

  return (
    <div className={styles.controlGroup}>
      <div className={styles.containerLeft}>
        <label className={styles.inputLabel}>Wins</label>
        <div className={styles.wrapper}>
          <span> {gameData.winningCounter}</span>
          <img src={win} alt="win" className={styles.win} />
        </div>
      </div>
      <div className={styles.containerRight}>
        <label className={styles.inputLabel}>Losses</label>
        <div className={styles.wrapper}>
          {gameData.losingCounter}
          <img src={lose} alt="lose" className={styles.lose} />
        </div>
      </div>
    </div>
  );
};

export default WinsAndLossesShow;
